import * as React from "react";
const SvgAccessPoint24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 23,
        height: 22,
        fill: "black",
        viewBox: "0 0 23 22"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M11.974 2.012a9 9 0 0 0-6.432 15.733L4.32 19.334A10.996 10.996 0 0 1 .515 10.42a11 11 0 1 1 18.165 8.913l-1.222-1.588.062-.056a9 9 0 0 0-5.546-15.678Zm5.303 12.94a6.96 6.96 0 0 1-1.042 1.204l-1.226-1.594a5.001 5.001 0 1 0-7.018 0l-1.226 1.594a7 7 0 1 1 10.512-1.203ZM10.5 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-3a3 3 0 0 0-.507 5.957l-.325.488-4 6L5.631 22H17.37l-1.037-1.555-4-6-.325-.488A3 3 0 0 0 11.5 8Zm0 8.803L13.632 20H9.369l2.131-3.197Z",
      clipRule: "evenodd"
    })
  );
export default SvgAccessPoint24Px;
